import { pick } from 'lodash';

import type { TCustomerUpdateData } from 'shared/types/TCustomerService';

import type { TCreditFormCommonFields } from 'entities/creditForm';

import { Additional, Addresses, Agreements, Auto, Contacts, CreditPurpose, Job, Passport } from '../formatters';

export const formDataToCustomerAdapter = (formData: Partial<TCreditFormCommonFields>): TCustomerUpdateData => {
  const auto = new Auto(formData).profile();
  const agreements = new Agreements(formData).profile();
  const passport = new Passport(formData).profile();
  const contacts = new Contacts(formData).profile();
  const creditPurpose = new CreditPurpose(formData).map();
  const addresses = new Addresses(formData).profile();
  const job = new Job(formData).profile();
  const additional = new Additional(formData).profile();

  const data: TCustomerUpdateData = {
    ...job,
    ...addresses,
    ...creditPurpose,
    ...contacts,
    ...passport,
    ...auto,
    ...agreements,
    ...additional,
  };

  return pick(data, [
    ...Object.keys(formData),
    ...(formData.lastWorkExperienceStartMonth ? ['lastWorkExperienceStartYear', 'jobType'] : ['jobType']),
  ]);
};
